import { Menu } from './menu'
import { isMobile } from 'utils/system/device'
import { CLASS_NAME } from 'constants/class-names'

/**
 * Menu
 * The root element controlBtn button,
 * and this controls menu that the control button attribute determines
 * special case: when mobile search elements exist in the menu
 */
export class MenuDriving extends Menu {
    /**
     * call all the logic for opening the menu
     */
    protected openMenu(): void {
        super.openMenu()
        // Adding class to make the menu droppable
        if (isMobile()) {
            this.menu.classList.add(CLASS_NAME.header.mainMenu.mobileDropMenu)
        }
    }
}
